import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import "./style.scss"
import { providerPrefix } from "configs/routePrefix"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"
import Paginator from "./Paginator/Paginator"
import CompoundService from "services/Provider/CompoundService"

const CompoundList = (props) => {
    const compoundService = new CompoundService()
    const [active, setActive] = useState('all')
    const [list, setList] = useState([])
    const [uploadModal, setUploadModal] = useState(false)
    const [filtersParams, setFilterParams] = useState(null)
    const [shouldGetData, setShouldGetData] = useState(false)
    const [searchWord, setSearchWord] = useState("")
    const [modal, setModal] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions.includes(data)
    const dispatch = useDispatch()
    const [noData, setNoData] = useState(false)
    const [filterData, setFilterData] = useState({
        area: null,
        country: null,
        fromRate: "",
        toRate: "",
    })
    const filter = useSelector(state=> state.adminFilter)

    const [pageOptions, setPageOptions] = useState({
        sizePerPage: 10,
        totalSize: 1,
    })
    useEffect(()=>{ 
        dispatch(appendFilters({developer_id: parseInt(props?.match?.params?.id)}))
    },[])

    const OnSearchChange = (e) => {
        const search = e.target.value
        setSearchWord(search)
    }

    useEffect(() => {
        setFilterData(filter)
            setTimeout(()=>{
                const params = {}
                params['developer_ids'] = parseInt(props?.match?.params?.id)
                if (!!filter ?.country) params['country'] = filter ?.country?.value //?.map(area => area.value).join()
                if (filter ?.location?.length > 0) params['area_ids'] = filter?.location?.map(area => area.value).join()
                if (active != 'all') params['status'] = active === "active" ? 1 : 0
                if (searchWord.trim()?.length) params['keyword'] = searchWord
                setFilterParams({ ...params })
            },1000)

    }, [active, searchWord, filter])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Compounds</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={12}>
                            <div className="d-flex mb-2">
                                <button className="p-0 m-0 border-0 me-2"
                                style={{background: 'none'}}
                                    onClick={() => {
                                        props.history.push(`${providerPrefix}/Admin-developer`)
                                    }}>
                                    <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                                </button>
                                <h4 className="m-0">Manage Compounds</h4>
                            </div>
                            <p>You can manage All Compounds in the Selected Developer</p>
                        </Col>
                        <Col md={6}>
                            <div className="form-group has-search">
                                <span className="fa fa-search form-control-feedback"></span>
                                <input type="text" className="form-control" placeholder="Search by Compound Name, I.D" onChange={(e) => OnSearchChange(e)}
                                    value={searchWord} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="my-4">
                        <Col md={6} sm={8} className="mb-3">
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "all" ? "#556ee6" : "#f4f4f4",
                                    color: active == "all" ? "#FFF" : "#495057"
                                }}
                                onClick={() => setActive("all")}
                            >
                                All
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "active" ? "#556ee6" : "#f4f4f4",
                                    color: active == "active" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("active")
                                }}
                            >
                                Active
                            </button>
                            <button
                                className="btn btnHeight me-2 px-4"
                                style={{
                                    background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                                    color: active == "deactive" ? "#FFF" : "#495057"
                                }}
                                onClick={() => {
                                    setActive("deactive")
                                }}
                            >
                                Deactive
                            </button>
                        </Col>
                        <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

                            <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                                setModal(!modal)
                            }}> <img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
                        </Col>
                    </Row>
                    <div>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <div className="py-3">
                                    <div>
                                        <div className="table-responsive position-relative">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14">I.D</th>
                                                        <th className="font-size-14">Compound Name</th>
                                                        <th className="font-size-14">Location</th>
                                                        <th className="font-size-14 width-174">No. of available units</th>
                                                        <th className="font-size-14">Total Rate</th>
                                                        <th className="font-size-14">status</th>
                                                        <th className="font-size-14"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.map(
                                                        (item, index) => (
                                                            <CardItem
                                                                key={index}
                                                                index={index}
                                                                {...item}
                                                                history={props.history}
                                                                itemData={item}
                                                                Service={CompoundService}
                                                                // updateHandler={() => updateHandler(item.id)}
                                                                setShouldGetData={setShouldGetData}

                                                            />
                                                        )
                                                    )}
                                                </tbody>
                                            </Table>
                                            {noData && <b style={{
                                                    left: '50%',
                                                    position: 'absolute',
                                                    transform: 'translate(-50%, 15px)'
                                                }}>
                                                   There's no compound in the selected developer
                                                </b>}
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-end">
                            <Col className="d-flex justify-content-between" md={12} sm={12}>
                                <Paginator
                                    service={compoundService}
                                    pageOptions={pageOptions}
                                    setData={(data) => {
                                        setList([...data])
                                        if(data?.length > 0){
                                            setNoData(false)
                                        } else{
                                            setNoData(true)
                                        }
                                    }}
                                    filter={filter}
                                    id= {parseInt(props?.match?.params?.id)}
                                    setPageOptions={setPageOptions}
                                    filtersParams={filtersParams}
                                    shouldGetData={shouldGetData}
                                    setShouldGetData={setShouldGetData}
                                />
                            </Col>
                        </Row >
                    </div>
                    {modal ? <FilterModal
                        modal={modal}
                        setModal={setModal}
                        updateFilter={setFilterData}
                        filters={filterData}
                    /> : null}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default CompoundList
